import {PublicHeader} from "./header";
import {PublicFooter} from "./footer";
import React from "react";

export const PublicPage = ({ children, showCountrySelector = true, showDeveloperLoginButton = true }: {
  children: React.ReactNode,
  showCountrySelector?: boolean,
  showDeveloperLoginButton?: boolean,
}) => {
  return <>
    <div className="flex flex-col min-h-screen">
      <PublicHeader showCountrySelector={showCountrySelector} />
      {children}
      <PublicFooter
        className="md:hidden"
        showDeveloperLoginButton={showDeveloperLoginButton}
      />
    </div>
    <PublicFooter
      className="hidden md:flex"
      showDeveloperLoginButton={showDeveloperLoginButton}
    />
  </>
}